import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { TokenExpiredError } from 'rate-command-center/domain/errors/TokenExpiredError'
import {
  isTokenExpiredError,
  type ResponseError,
} from 'rate-command-center/infra/RateCommandCenterRepository'

import { createAllInOneHttpClient } from '../../core/infra/createAllInOneHttpClient'
import { PendingTendersRepository } from '../infra/PendingTendersRepository'

export type GetPendingTendersFactoryDependencies = {
  repository: PendingTendersRepository
  config?: Partial<HttpClientConfig>
}

type Params = {
  config?: Partial<HttpClientConfig>
}

export function getPendingTendersFactory({
  repository,
  config,
}: GetPendingTendersFactoryDependencies) {
  return async function getPaginatedRatesByStatus() {
    try {
      return await repository.getPendingTenders({
        config,
      })
    } catch (error) {
      if (isTokenExpiredError(error as ResponseError)) {
        throw new TokenExpiredError()
      } else {
        throw new Error('Could not get rates', { cause: error as Error })
      }
    }
  }
}

export function getPendingTenders({ config }: Params) {
  const httpClient = createAllInOneHttpClient()
  const repository = new PendingTendersRepository({ httpClient })
  const newGetPendingTenders = getPendingTendersFactory({
    repository,
    config,
  })
  return newGetPendingTenders()
}
